module.exports = __webpack_public_path__ + "static/media/949.947c75fd.jpg";